import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'

import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)
const requireModule = require.context('@/store/modules', true, /\.js$/)
const modules = requireModule.keys().reduce((modules, modulePath) => {
    let moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
    let value = requireModule(modulePath)
    modules[moduleName] = value.default
  return modules
}, {})	//模块注册

const store = new Vuex.Store({
  modules,
  getters,
  plugins: [
    // veux持久化配置
    createPersistedState({
      key: 'rabbitstore-client',
      paths: ['user']
    })
  ]
})

export default store
